import { classNames } from "primereact/utils";
import { useMemo } from "react";

export const useClassNames = (
  toggleClasses: { [key in string]: boolean },
  ...classes: (string | null | undefined)[]
) =>
  useMemo(
    () => `${classNames(toggleClasses)} ${classes?.filter((c) => !!c).join(" ")}`,
    [toggleClasses, classes],
  );
